<template>
  <div>
    <v-list-item
      :key="`d-${index}`"
      :value="source.id"
      inactive
      @click.capture.stop="onItemSelect(source)"
    >
      <v-list-item-action class="mr-1">
        <v-checkbox
          color="primary"
          v-model="checkboxes"
          :value="source.id"
        ></v-checkbox>
      </v-list-item-action>
      <v-list-item-content v-if="drawerType === 'schedule'" class="pa-1">
        <v-list-item-title>
          {{ source.projects.name }}
        </v-list-item-title>
        <v-list-item-subtitle>
          {{ source.date }} {{ source.periods.name }}
        </v-list-item-subtitle>
        <v-list-item-action-text>
          <v-chip small label color="error" class="pr-1 pl-1 mt-1 mr-1">{{
            `待批阅 ${source.rpt_submit}`
          }}</v-chip>
          <v-chip small label color="success" class="pr-1 pl-1 mt-1 mr-1">{{
            `已批阅 ${source.rpt_check}`
          }}</v-chip>
          <v-chip small label color="warning" class="pr-1 pl-1 mt-1 mr-1">{{
            `已退回 ${source.rpt_sendback}`
          }}</v-chip>
          <v-chip small label color="warning" class="pr-1 pl-1 mt-1 mr-1">{{
            `存草稿 ${source.rpt_draft}`
          }}</v-chip>
          <v-chip small label class="pr-1 pl-1 mt-1 mr-1">{{
            `未提交 ${source.current_student_number -
              source.rpt_submit -
              source.rpt_check -
              source.rpt_sendback -
              source.rpt_draft}`
          }}</v-chip>
          <v-chip small label class="pr-1 pl-1 mt-1">{{
            `总计 ${source.current_student_number}`
          }}</v-chip>
        </v-list-item-action-text>
      </v-list-item-content>
      <v-list-item-content v-else-if="drawerType === 'student'" class="pa-1">
        <v-list-item-title v-if="isOrg">
          {{ source.name }}
        </v-list-item-title>
        <v-list-item-title v-else>
          {{ source.code }} - {{ source.name }}
        </v-list-item-title>
        <v-list-item-action-text>
          <v-chip small label color="error" class="pr-1 pl-1 mt-1 mr-1">{{
            `待批阅 ${source.rpt_submit}`
          }}</v-chip>
          <v-chip small label color="success" class="pr-1 pl-1 mt-1 mr-1">{{
            `已批阅 ${source.rpt_check}`
          }}</v-chip>
          <v-chip small label color="warning" class="pr-1 pl-1 mt-1 mr-1">{{
            `已退回 ${source.rpt_sendback}`
          }}</v-chip>
          <v-chip small label color="warning" class="pr-1 pl-1 mt-1 mr-1">{{
            `存草稿 ${source.rpt_draft}`
          }}</v-chip>
          <v-chip small label class="pr-1 pl-1 mt-1 mr-1">{{
            `未提交 ${source.total -
              source.rpt_submit -
              source.rpt_check -
              source.rpt_sendback -
              source.rpt_draft}`
          }}</v-chip>
          <v-chip small label class="pr-1 pl-1 mt-1">{{
            `总计 ${source.total}`
          }}</v-chip>
        </v-list-item-action-text>
      </v-list-item-content>
    </v-list-item>
    <v-divider :key="index"></v-divider>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'todo-item',
  props: {
    onItemSelect: {
      type: Function
    },
    index: {
      // index of current item
      type: Number
    },
    source: {
      type: Object,
      default() {
        return {};
      }
    },
    submitOnly: {
      type: Boolean
    },
    sendbackOnly: {
      type: Boolean
    },
    checkboxes: {
      type: Array
    }
  },
  computed: {
    ...mapGetters(['drawerType', 'isOrg'])
  }
};
</script>
